/**
 * Brand name mapping for logo files
 * 
 * This file maps different variations of brand names to their corresponding logo filenames.
 * Use this to handle cases where the same brand might be referred to in different ways in the data.
 * 
 * Format:
 * 'brand name variation': 'actual-logo-filename.svg'
 */

const brandMapping = {
  // Autovisie
  'autovisie': 'autovisie.svg',
  'auto visie': 'autovisie.svg',
  
  // Bedrock
  'bedrock': 'bedrock.svg',
  'bed rock': 'bedrock.svg',
  'nieuwsbriefbedrock': 'bedrock.svg',
  
  // Culy
  'culy': 'culy.svg',
  
  // Dagblad van het Noorden
  'dagblad van het noorden': 'dagblad van het noorden.svg',
  'dagbladvanhetnoorden': 'dagblad van het noorden.svg',
  'dvhn': 'dagblad van het noorden.svg',
  'dvhn homepage': 'dagblad van het noorden.svg',
  'dagblad van het noorden groningen': 'dagblad van het noorden.svg',
  'dagblad van het noorden groningen - noord': 'dagblad van het noorden.svg',
  'dagblad van het noorden groningen - oost': 'dagblad van het noorden.svg',
  'dagblad van het noorden drenthe': 'dagblad van het noorden.svg',
  'dagblad van het noorden drenthe - west': 'dagblad van het noorden.svg',
  'dagblad van het noorden drenthe - zuid': 'dagblad van het noorden.svg',
  'nieuwsbriefdvhncultuur': 'dagblad van het noorden.svg',
  'nieuwsbriefdvhnochtend': 'dagblad van het noorden.svg',
  // De Limburger
  'delimburgerheleoplage': 'de limburger.svg',
  'delimburgermaastrichtheuvelland': 'de limburger.svg',
  'delimburgermiddenlimburg': 'de limburger.svg',
  'delimburgernoordlimburg': 'de limburger.svg',
  'delimburgerwestelijkemijnstreek': 'de limburger.svg',
  'delimburgerparkstadlimburg': 'de limburger.svg',
  'de limburger': 'de limburger.svg',
  'limburger': 'de limburger.svg',
  'delimburger': 'de limburger.svg',
  'limburger homepage': 'de limburger.svg',
  'nieuwsbriefdelimburgermiddagupdate': 'de limburger.svg',
  'nieuwsbriefdelimburgerregio': 'de limburger.svg',
  
  // De Telegraaf
  'de telegraaf': 'de telegraaf.svg',
  'telegraaf': 'de telegraaf.svg',
  'detelegraaf': 'de telegraaf.svg',
  'de telegraaf, editie Amsterdam': 'de telegraaf.svg',
  'De Telegraaf editie Amsterdam': 'de telegraaf.svg',
  "detelegraafeditieamsterdam": 'de telegraaf.svg',
  'de telegraaf + mediahuis regionale dagbladen west': 'de telegraaf.svg',
  'telegraafyoutube': 'de telegraaf.svg',
  'telegraaf.nl': 'de telegraaf.svg',
  'telegraafentertainment': 'de telegraaf.svg',
  'telegraafentertainmenthomepage': 'de telegraaf.svg',
  'telegraaffinancieel': 'de telegraaf.svg',
  'telegraaffinancieelhomepage': 'de telegraaf.svg',
  'telegraafnieuws': 'de telegraaf.svg',
  'telegraafnieuwshomepage': 'de telegraaf.svg',
  'telegraafnieuws': 'de telegraaf.svg',
  'telegraafhomepage': 'de telegraaf.svg',
  'telegraafhomepagearticles': 'de telegraaf.svg',
  'telegraaflifestyle': 'de telegraaf.svg',
  'telegraaflifestylehomepage': 'de telegraaf.svg',
  'telegraafsport': 'de telegraaf.svg',
  'telegraafsporthomepage': 'de telegraaf.svg',
  'telegraafsubsectieshomepages': 'de telegraaf.svg',
  'telegraafvideo': 'de telegraaf.svg',
  'telegraafvrouw': 'de telegraaf.svg',
  'telegraafvrouwhomepage': 'de telegraaf.svg',
  'nieuwsbriefdetelegraafzondag': 'de telegraaf.svg',
  'nieuwsbriefdetelegraaflunchupdate': 'de telegraaf.svg',
  
  // Drachtser Courant
  'drachtser courant': 'drachtser courant.svg',
  'drachtsercourant': 'drachtser courant.svg',
  
  // Dumpert
  'dumpert': 'dumpert.svg',
  
  // Famme
  'famme': 'famme.svg',
  'nieuwsbriefhetbestevanfamme': 'famme.svg',
  
  // Gooi en Eemlander
  'De Gooi- en Eemlander': 'gooi en eemlander.svg',
  'gooi en eemlander': 'gooi en eemlander.svg',
  'gooieneemlander': 'gooi en eemlander.svg',
  'degooieneemlander': 'gooi en eemlander.svg',
  'gooi & eemlander': 'gooi en eemlander.svg',
  'gooieneemlander homepage': 'gooi en eemlander.svg',
  // Haarlems Dagblad
  'haarlems dagblad': 'haarlems dagblad.svg',
  'haarlemsdagblad': 'haarlems dagblad.svg',
  'haarlems': 'haarlems dagblad.svg',
  'haarlemsdagblad homepage': 'haarlems dagblad.svg',
  // IJmuider Courant
  'ijmuider courant': 'ijmuider courant.svg',
  'ijmuidercourant': 'ijmuider courant.svg',
  'ijmuidercourant homepage': 'ijmuider courant.svg',
  
  // JMOuders
  'jmouders': 'jmouders.svg',
  'jm ouders': 'jmouders.svg',
  
  // Leeuwarder Courant
  'leeuwarder courant': 'leeuwarder courant.svg',
  'leeuwarden courant': 'leeuwarder courant.svg',
  'leeuwarden': 'leeuwarder courant.svg',
  'leeuwcourant': 'leeuwarder courant.svg',
  'leeuwardercourant': 'leeuwarder courant.svg',
  'leeuwardercourant homepage': 'leeuwarder courant.svg',
  // Leidsch Dagblad
  'leidsch dagblad': 'leidsch dagblad.svg',
  'leidschdagblad': 'leidsch dagblad.svg',
  'leids dagblad': 'leidsch dagblad.svg',
  'leidsdagblad': 'leidsch dagblad.svg',
  'leidschdagblad homepage': 'leidsch dagblad.svg',
  
  // Friesch Dagblad
  'friesch dagblad': 'logo-frieschdagblad.svg',
  'frieschdagblad': 'logo-frieschdagblad.svg',
  'fries dagblad': 'logo-frieschdagblad.svg',
  'friesdagblad': 'logo-frieschdagblad.svg',
  'frieschdagblad homepage': 'logo-frieschdagblad.svg',
  // Hah Leeuwarden
  'hah leeuwarden': 'logo-hahleeuwarden.svg',
  'hahleeuwarden': 'logo-hahleeuwarden.svg',
  
  // Heerenveense Courant
  'heerenveense courant': 'logo-heerenveense.svg',
  'heerenveense': 'logo-heerenveense.svg',
  'heerenveensecourant': 'logo-heerenveense.svg',
  
  // Sneeker Nieuwsblad
  'sneeker nieuwsblad': 'logo-sneeker.svg',
  'sneeker': 'logo-sneeker.svg',
  'sneekercourant': 'logo-sneeker.svg',
  'sneeker courant': 'logo-sneeker.svg',
  
  // Regional newspapers and local publications
  'asser courant': 'AsserCourant.jpg',
  'balkster courant abo': 'Week en Nieuwsbladen.jpg',
  'bolswards nieuwsblad': 'BolswardsNieuwsblad.jpg',
  'coevorder courant': 'CoevorderCourant.jpg',
  'de feanster': 'DeFeanster.jpg',
  'de krant van midden drenthe': 'DeKranVanMidden-Drenthe.jpg',
  'de noordoostpolder': 'DeNoordoostpolder.jpg',
  'de staphorster': 'DeStaphorster.jpg',
  'drachtster courant': 'DrachtsterCourant.jpg',
  'eemsbode': 'Eemsbode.jpg',
  'emmer courant': 'EmmerCourant.jpg',
  'flevopost dronten': 'Week en Nieuwsbladen.jpg',
  'flevopost lelystad': 'Week en Nieuwsbladen.jpg',
  'franeker courant': 'FranekerCourant.jpg',
  'groninger gezinsbode': 'GroningerGezinsbode.jpg',
  'hs-krant': 'HS-Krant.jpg',
  'heerenveense courant': 'HeerenveenseCourant.jpg',
  'hoogeveensche courant abo': 'Week en Nieuwsbladen.jpg',
  'hoogeveensche courant': 'Week en Nieuwsbladen.jpg',
  'huis aan huis leeuwarden': 'HuisAanHuisLeeuwarden.jpg',
  'jouster courant': 'JousterCourant.jpg',
  'kanaalstreek': 'Kanaalstreek.jpg',
  'meppeler courant abo': 'Week en Nieuwsbladen.jpg',
  'meppeler courant': 'Week en Nieuwsbladen.jpg',
  'nieuwe dockumer courant': 'NieuweDockumerCourant.jpg',
  'nieuwe ooststellingwerver abo': 'Week en Nieuwsbladen.jpg',
  'nieuwe ooststellingwerver': 'Week en Nieuwsbladen.jpg',
  'nieuwsblad noordoost-friesland abo': 'Week en Nieuwsbladen.jpg',
  'noorderkrant': 'Noorderkrant.jpg',
  'roder journaal': 'RoderJournaal.jpg',
  'steenwijker courant abo': 'Week en Nieuwsbladen.jpg',
  'steenwijker courant': 'Week en Nieuwsbladen.jpg',
  'stellingwerf abo': 'Week en Nieuwsbladen.jpg',
  'stellingwerf': 'Week en Nieuwsbladen.jpg',
  'streekblad': 'Streekblad.jpg',
  'veendammer': 'Veendammer.jpg',
  'westerkwartier': 'Westerkwartier.jpg',
  'westervelder wolder courant': 'Westervelder Wolder Courant.jpg',
  
  // Manners
  'manners': 'manners.svg',
  
  // Metro Nieuws
  'metro nieuws': 'metronieuws.svg',
  'metronieuws': 'metronieuws.svg',
  'metro': 'metronieuws.svg',
  
  // Noordhollands Dagblad
  'noordhollands dagblad': 'nhd.svg',
  'noordhollandsdagblad': 'nhd.svg',
  'nhd': 'nhd.svg',
  'noord hollands dagblad': 'nhd.svg',
  'noord-hollands dagblad': 'nhd.svg',
  
  // Noordhollands Dagblad (original)
  'noordhollands dagblad org': 'nhd-org.svg',
  'nhd org': 'nhd-org.svg',
  'nhd-org': 'nhd-org.svg',
  
  // NSMBL
  'nsmbl': 'nsmbl.svg',
  
  // Radio Veronica
  'radio veronica': 'radio veronica.svg',
  'radioveronica': 'radio veronica.svg',
  'veronica': 'radio veronica.svg',
  
  // Want
  'want': 'want.svg',
  
  // NRC (not in the directory but in your original mapping)
  'nrc handelsblad': 'nrc.svg',
  'nrc': 'nrc.svg',
  'nrchandelsblad': 'nrc.svg',


  // Sublime
  'sublime': 'sublime.svg',
  'sublime homepage': 'sublime.svg',
  // Sunlite
  'sunlite': 'sunlite.svg',
  'sunlite homepage': 'sunlite.svg',
  // 100p
  '100p': '100p.svg',
  '100p homepage': '100p.svg',
  '100procentnl': '100p.svg',
  // Slam
  'slam': 'slam.svg',
  
};

/**
 * Get the correct logo filename for a brand
 * @param {string} brandName - The brand name to look up
 * @returns {string} The correct logo filename or null if not found in mapping
 */
export const getBrandLogoFilename = (brandName) => {
  // console.log('🔍 getBrandLogoFilename called with:', brandName);
  
  if (!brandName) return null;
  
  // Convert to lowercase for case-insensitive matching
  const normalizedName = brandName.toLowerCase()
    .replace(/\.nl/gi, '')  // Remove .nl domain
    .trim();
  
  // console.log('📝 Normalized name:', normalizedName);
  
  // Check if we have a direct mapping
  if (brandMapping[normalizedName]) {
    // console.log('✅ Found direct mapping:', brandMapping[normalizedName]);
    return brandMapping[normalizedName];
  }
  
  // Try without special characters
  const cleanName = normalizedName.replace(/[^a-z0-9\s]/g, '').trim();
  // console.log('🧹 Clean name (no special chars):', cleanName);
  
  if (brandMapping[cleanName]) {
    // console.log('✅ Found mapping for clean name:', brandMapping[cleanName]);
    return brandMapping[cleanName];
  }
  
  // Try without spaces
  const noSpaces = cleanName.replace(/\s+/g, '');
  // console.log('🚫 No spaces name:', noSpaces);
  
  if (brandMapping[noSpaces]) {
    // console.log('✅ Found mapping for no spaces:', brandMapping[noSpaces]);
    return brandMapping[noSpaces];
  }
  
  // No mapping found
  // console.log('❌ No mapping found for:', brandName);
  return null;
};

export default brandMapping; 